export default __webpack_public_path__ + "static/elizabeth-99bde1c08647f9eaaf1cb9a0e69cd23b.png";